import React from 'react';
import { CheckIcon } from 'lucide-react';
const trustItems = ['Custom software engineered for your exact requirements', 'Proven expertise in web, mobile, and enterprise systems', 'AI and automation capabilities that drive efficiency', 'Scalable architecture built for growth', 'Long-term partnership and ongoing support'];
export function TrustBar() {
  return <section className="py-12 border-y border-border bg-surface texture-light" data-id="element-356">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-357">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-6 text-center scroll-fade-in" data-id="element-358">
          {trustItems.map((text, i) => <div key={i} className="flex flex-col items-center" data-id="element-359">
              <CheckIcon className="w-6 h-6 text-accent mb-2" data-id="element-360" />
              <p className="text-sm font-medium text-ink" data-id="element-361">{text}</p>
            </div>)}
        </div>
      </div>
    </section>;
}